import { Suspense, useEffect } from 'react';
import { useQuery } from 'react-query';
import * as apiClient from '../../api-client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Loader from '../../components/LoaderComponent';
import Dealsupto2000List from '../../components/HotelCard/Dealsupto2000List';
import React from 'react';

const LatestDestinationsSlider = React.lazy(() => import('../../components/LatestDestinationsSlider'));

const Dealsupto2000 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const { data: hotels, error} = useQuery('fetchHotels', apiClient.fetchHotels);

  if (error) return <div>Error loading hotels.</div>;

  const dealsupto2000mob = hotels?.filter(hotel => hotel.pricePerNight >= 1000 && hotel.pricePerNight <= 2000) || [];

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Deals up to $2000 | Halo Holidays</title>
          <meta name="description" content="Find the best hotel deals under 300 per night." />
          <meta name="keywords" content="travel, hotels, deals, affordable hotels, budget travel" />
        </Helmet>
      </HelmetProvider>
      <main className=" md:mx-0 lg:mx-0 space-y-12">
        <section className="fade-in ">
          <h2 className="mx-5 md:mx-0 lg:mx-0 text-3xl font-semibold " >Deals upto $2000</h2>
          <p className='mx-5 md:mx-0 lg:mx-0 text-black mb-4'>Find the best deals on packages under $2000.</p>
       <div className="hidden md:block lg:block">
          <Suspense fallback={<Loader />}>
            <Dealsupto2000List hotels={hotels ?? []} />
          </Suspense>
        </div>
            <div className="block md:hidden lg:hidden">
           <Suspense fallback={<Loader />}>
            <LatestDestinationsSlider hotels={dealsupto2000mob} />
          </Suspense>
          </div>
        </section>

      </main>
    </>
  );
};

export default Dealsupto2000;
